// extracted by mini-css-extract-plugin
export default {"item-list":"SaladsDesktop_item-list__o39UZ","item":"SaladsDesktop_item__iqGAI","category-title":"SaladsDesktop_category-title__frNSq"};